module.exports = __webpack_public_path__ + "home-block-1-ico-1@2x-MsmVFgu.png";